
import { Component, Vue } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'

import { ResizeObserver } from 'resize-observer'

import { Auth } from '@/middlewares/Auth'

@Component({
  components: {
    BacLoggedInHeader,
    BacHeaderWithMenue
  }
})
export default class App extends Vue {
  headerWithMenuSize = 0
  registerRestOfBodyHeightWatcher () {
    const header = document.getElementsByClassName('header')[0]
    const resizeObserver = new ResizeObserver(this.fixHeightOfBodySize)
    if (header) {
      resizeObserver.observe(header)
    }
    if (document.body) {
      resizeObserver.observe(document.body)
    }
    const heightOfBodyElements = document.getElementsByClassName('height-rest-of-body')
    for (let i = 0; i < heightOfBodyElements.length; i++) {
      if (heightOfBodyElements[i]) {
        resizeObserver.observe(heightOfBodyElements[i])
      }
    }

    // ugly, but somtimes resize observer doesn't trigger
    setInterval(this.fixHeightOfBodySize, 500)
  }

  fixHeightOfBodySize () {
    const header = document.getElementsByClassName('header')[0]
    const heightOfBodyElements = document.getElementsByClassName('height-rest-of-body')
    for (let i = 0; i < heightOfBodyElements.length; i++) {
      if (document.documentElement.scrollHeight - 50 <= document.documentElement.offsetHeight) {
        (heightOfBodyElements[i] as HTMLElement).style.height = `calc(100% - ${(header as HTMLElement).offsetHeight}px`
      } else {
        (heightOfBodyElements[i] as HTMLElement).style.height = ''
      }
    }
  }

  mounted () {
    this.registerRestOfBodyHeightWatcher()
    this.handleAuth()
  }

  async handleAuth () {
    if (!Auth.routesWithoutAuth.includes((this.$route as any).name)) {
      // Route requires Authentication
      const accessToken = window.localStorage.getItem('accessToken')
      if (!accessToken) {
        this.$router.push('/')
      }
      const success = await Auth.tryLogin()
      if (!success) {
        window.localStorage.removeItem('accessToken')
        this.$router.push('/')
      }
    }
  }
}
